import { createSlice } from '@reduxjs/toolkit';

/**
 * Setting the status of the workflow
 * {
 * [jid]:{ //jid is the id of the transaction
 *    wfStatus: 100, //number
 *    jStatus: 1, //number
 *  }
 * }
 */
const INITIAL_STATE = {};

const slice = createSlice({
  name: 'wf',
  initialState: INITIAL_STATE,
  reducers: {
    setStatus(state, action) {
      const { jid, wfStatus, jStatus } = action.payload;
      const current = state[jid] || {};
      const nextJStatus =
        jStatus !== undefined ? jStatus : current.jStatus ?? 0;
      if (current.wfStatus === wfStatus && current.jStatus === nextJStatus) {
        // No change, don't update
        return state;
      }
      const updatedState = {
        ...state,
        [jid]: {
          wfStatus,
          jStatus: jStatus !== undefined ? jStatus : state[jid]?.jStatus ?? 0 // Default to 0 if nothing exists
        }
      };
      return updatedState;
    },
    batchUpdateStatus(state, action) {
      const updates = action.payload; // Expecting an array of { jid, wfStatus, jStatus }
      Object.entries(updates).forEach(([jid, { wfStatus, jStatus }]) => {
        state[jid] = { wfStatus, jStatus };
      });
    },
    clear() {
      return INITIAL_STATE;
    },
    restore(_, action) {
      return action.payload || INITIAL_STATE;
    }
  }
});

const wfReducer = slice.reducer;

export const { setStatus, batchUpdateStatus, restore, clear } = slice.actions;
export default wfReducer;
